import { Address } from '@vsolv/core/address/domain';

export const CLAIM_CALLER_NAME_MAX_LENGTH = 255;
export const CLAIM_CALLER_CONTACT_MAX_LENGTH = 255;
export const CLAIM_REPAIR_ORDER_REFERENCE_MAX_LENGTH = 100;

export enum CallerType {
  CONTRACT_HOLDER = 'CONTRACT_HOLDER',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  OTHER = 'OTHER',
}

/** Why the adjuster needs to call the customer or shop. */
export enum ContactReason {
  CLARIFYING_QUESTION = 'CLARIFYING_QUESTION',
  MISSING_INFORMATION = 'MISSING_INFORMATION',
  SHARE_DECISION = 'SHARE_DECISION',
  REPAIR_STATUS = 'REPAIR_STATUS',
  OTHER = 'OTHER',
}

/** Who reported the claim. */
export interface Caller {
  name: string;
  type: CallerType;
  contact: string | null;
}

/** Keyed by a scalar dimension of the asset's property set (e.g. odometer). */
export interface UsageAtLoss {
  dimensionId: string;
  value: number;
}

/** Copied on assignment; directory edits don't change it. */
export interface ServiceProviderSnapshot {
  name: string;
  email: string | null;
  phone: string | null;
  mainContact: string | null;
  taxId: string | null;
  address: Address.Model | null;
}
